module.exports = __webpack_public_path__ + "images/kaitori_bonus_lp/step-4-img-sp@2x_e3341f20629833ef625f49c73b7fd885.png";